import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'currency-formatter';

import { environment as ENV } from '@environment';

@Pipe({
  name: 'exchangeCurrency',
  standalone: false
})
export class ExchangeCurrencyPipe implements PipeTransform {

  constructor() { }

  transform(price: number, rate: number, isOriginalPrecision: boolean = false): string {
    const convertPrice = this.convertByExchangeRate(price, rate);
    const currencyCode = ENV.countryModules?.booking?.exchange_rate?.currency_to;
    const formatedPrice = format(
      isOriginalPrecision ? convertPrice : this.round(convertPrice, ENV.currency_precision), {
        code: currencyCode,
        precision: isOriginalPrecision ? this.originalPrecision(convertPrice.toString()) : ENV.currency_precision,
        format: '%s%v'
      });
    return ENV.countryModules?.booking?.exchange_rate?.show_currency_sufix ?
      `${formatedPrice} ${currencyCode}` : `${formatedPrice}`;
  }

  private convertByExchangeRate(amount: number = 0, rate: number = 0): number {
    return rate ? amount * rate : amount;
  }

  private round(value: number, decimalQuantity: number = 0): string | number {
    const decimal = Math.pow(10, decimalQuantity);
    return value ? Math.round(value * decimal) / decimal : value;
  }

  private originalPrecision(price: string): number {
    return price.indexOf('.') >= 0 ? (price.length - 1) - price.indexOf('.') : 0;
  }
}
